import React from 'react'

export default function PageNotFound() {
  return (
    <div>Hello 404</div>
  )
}